import React, { useRef, useState } from 'react'
import { MdArrowForwardIos } from "react-icons/md";

const Faq = ({ quests }) => {

  const [selected, setSelected] = useState()
  const answerRefs = useRef([])
  const questions = [
    {
      "title": "Hvad er Stripe?",
      "answer": "Stripe er en af verdens førende betalingsplatforme, der håndterer betalinger for virksomheder i alle størrelser. De sørger for sikre og hurtige transaktioner, så du trygt kan modtage dine penge."
    },
    {
      "title": "Gemmer I mine bankoplysninger?",
      "answer": "Nej, vi gemmer ikke dine bankoplysninger. Alle følsomme oplysninger håndteres af Stripe, som sørger for, at alt er krypteret og sikkert."
    },
    {
      "title": "Hvorfor skal jeg angive en bankkonto?",
      "answer": "Du skal angive din bankkonto, så vi kan udbetale dine penge, når du har solgt en bog. Stripe bruger dine oplysninger til at overføre beløbet direkte til din konto, uden at vi selv opbevarer dine bankdata."
    },
    {
      "title": "Hvorfor?",
      "answer": "Stripe er en af verdens førende betalingsplatforme, der håndterer betalinger for virksomheder i alle størrelser. De sørger for sikre og hurtige transaktioner, så du trygt kan modtage dine penge."
    },
    {
      "title": "Bliver min adresse delt med køberen?",
      "answer": "Din adresse deles kun, hvis du vælger, at køberen kan afhente bogen på din private adresse. I så fald vil by og postnummer være tilgængelige for alle, imens din fulde adresse kun oplyses til den endelige køber, efter betalingen er gennemført."
    },
    {
      "title": "Hvad?",
      "answer": "Du skal angive din bankkonto, så vi kan udbetale dine penge, når du har solgt en bog. Stripe bruger dine oplysninger til at overføre beløbet direkte til din konto, uden at vi selv opbevarer dine bankdata."
    }
  ]

  return (
    <div className="text-base w-full flex-1">
      <div className="bg-emerald-200 text-emerald-800 font-semibold px-2 w-fit text-sm"><p>Ofte stillede spørgsmål</p></div>
      {questions.map((question, index) => {
        if (quests.includes(index + 1)) {
          return (
            <div className={"border-b border-neutral-200 p-5 w-full cursor-pointer" + (selected === index ? " space-y-2" : "")} onClick={() => setSelected((prev => prev === index ? null : index))}>
              <div className="flex justify-between items-center">
                <h2 className="font-medium">{question.title}</h2>
                <MdArrowForwardIos className={`${selected === index && "rotate-90"} duration-300 ease-in-out`} />
              </div>
              <div ref={el => (answerRefs.current[index] = el)}
                className="overflow-hidden transition-max-height duration-300 ease-in-out"
                style={{ maxHeight: selected === index ? `${answerRefs.current[index]?.scrollHeight}px` : "0" }}
              >
                <p className="text-base">{question.answer}</p>
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

export default Faq